
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import TitleHeader from "@/components/base/table/header/LeftLineHeader.vue";
import { State, Getter, Action } from "vuex-class";
import { validForm } from "@/common/utils";
import { FormValid } from "@/config";
import cookie from "js-cookie";
import { md5 } from "@/toolUtil/md5";

@Component({
  name: "Setting",
  components: { TitleHeader },
})
export default class Setting extends Vue {
  @Action("account/getAuthernData") private getAuthernData: any;
  @Getter("phone") private phone!: any;
  @Getter("company") private company!: any;
  @Getter("account") private account!: any;
  @Getter("role") private role!: any;
  @Getter("id") private id!: any;
  @Action("account/getMail") private getMail: any;
  @Action("account/getMailUnvalid") private getMailUnvalid: any;
  @Action("account/updatePassword") private updatePassword: any;
  @Action("account/updatePhone") private updatePhone: any;
  is_fix_phone = false;
  is_fix_password = false;
  ref_account_form = "ref_account_form";
  ref_fix_phone = "ref_fix_phone";
  ref_fix_password = "ref_fix_password";
  phone_model: any = {};
  password_model: any = {};
  account_model: any = {
    account: "",
    phone: "",
    password: "",
  };
  rules_phone: any = {
    password: [
      {
        required: true,
        message: "请输入密码",
        trigger: "change",
      },
      { validator: FormValid.password },
    ],
    phone: [
      {
        required: true,
        message: "请输入手机号",
        trigger: "change",
      },
      { validator: FormValid.phone },
    ],
  };
  rules_password: any = {
    phone: [
      {
        required: true,
        message: "请输入手机号",
        trigger: "change",
      },
    ],
    code: [
      {
        required: true,
        message: "请输入验证码",
        trigger: "change",
      },
    ],
    password: [
      {
        required: true,
        message: "请输入密码",
        trigger: "change",
      },
      { validator: FormValid.password },
    ],
    repassword: [
      {
        required: true,
        message: "请输入重复密码",
        trigger: "change",
      },
      { validator: FormValid.password },
    ],
  };
  sendCodeText = "发送验证码";
  num = 60;
  timer: any = "";
  isSend = false;
  countDown() {
    if (this.num > 0) {
      this.num -= 1;
      this.setTimeCookie(String(this.num));
      this.sendCodeText = `${this.num}秒后`;
      this.timer = setTimeout(this.countDown, 1000);
      this.isSend = true;
    } else {
      this.resetCountDown();
    }
  }
  resetCountDown() {
    clearTimeout(this.timer);
    this.timer = null;
    this.num = 60;
    this.sendCodeText = "发送验证码";
    this.isSend = false;
  }
  created() {
    const num = Number(this.getTimeCookie());
    if (num >= 0) {
      this.num = num;
      this.requestId_password = this.getId() as string;
      this.countDown();
    }
    this.account_model = {
      phone: this.phone,
      password: "******",
      account: this.account || this.company,
    };
    this.getAuthern();
  }
  unitName: any = "";
  async getAuthern() {
    const data = await this.getAuthernData();

    if (data) {
      const {
        unitName,
        legalName,
        legalNumber,
        phone,
        unitRegisteredAddress,
        unitSoleNumber,
        charter: charterUrl,
      } = data;
      this.unitName = unitName;
    }
  }
  openPhone() {
    this.is_fix_phone = true;
    // this.phone_model.phone = this.phone;
  }
  openPassword() {
    this.is_fix_password = true;
    this.password_model.phone = this.phone;
  }
  cancelFixPassword() {
    this.is_fix_password = false;
  }
  cancelFixPhone() {
    this.is_fix_phone = false;
  }
  requestId_phone = "";
  requestId_password = "";
  sendPasswordCode() {
    const reg = /^1[345789]\d{9}$/;
    const { phone } = this.password_model;
    if (phone !== this.phone) {
      return this.$message.warning("请正确的填写手机号");
    }
    const options = { mobile: phone, verificationEnums: "FIND_USER" };
    this.getMail(options).then((res: any) => {
      if (res) {
        // this.requestId_password = res;
        this.setTimeCookie();
        // this.setId(res);
        this.countDown();
        return res;
      }
    });
  }
  setId(id: string) {
    cookie.set(`codeId`, id);
  }
  getId() {
    return cookie.get(`codeId`);
  }
  setTimeCookie(time = "60") {
    cookie.set(`codeTime`, time);
  }
  getTimeCookie() {
    return cookie.get(`codeTime`);
  }
  sendPhoneCode() {
    const reg = /^1[345789]\d{9}$/;
    const { phone } = this.phone_model;

    if (!reg.test(phone)) {
      return this.$message.warning("请正确的填写手机号");
    }

    const options = { mobile: phone, verificationEnums: "FIND_USER" };
    this.getMail(options).then((res: any) => {
      if (res) {
        this.requestId_phone = res;
        this.countDown();
        return res;
      }
    });
  }
  async fixPhone() {
    const { phone, code, password } = this.phone_model;
    const ref = this.$refs[this.ref_fix_phone] as any;
    const state = await validForm(ref);
    if (!state || phone === this.phone) {
      return this.$message.warning("请正确的填写新的手机号码");
    }
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    const options = {
      code,
      password,
      phone,
      // requestId: this.requestId_phone,
      // id: this.id,
      // idNature: this.role,
    };
    setTimeout(() => {
      loading && loading.close();
    }, 30000);
    this.updatePassword(options).then(({ code, data }: any) => {
      loading && loading.close();
      this.phone_model = {};
      if (code == 200) {
        this.is_fix_phone = false;
        this.$message.success("成功修改手机号");
        return this.$router.push({ path: "/login" });
      }
      return data;
    });
  }
  async fixPassword() {
    const { phone, code, password, repassword } = this.password_model;
    const ref = this.$refs[this.ref_fix_password] as any;
    const state = await validForm(ref);
    if (password !== repassword) {
      return this.$message.warning("请输入一致的密码");
    }
    if (!state) {
      // return this.$message.warning("请正确的输入表单信息")
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    const options = {
      mobile: phone,
      code,
      // password: btoa(password),
      password: md5(password),
      // id: this.id,
      // requestId: this.requestId_password,
    };
    setTimeout(() => {
      loading && loading.close();
    }, 30000);
    this.updatePassword(options).then(({ code, data, message }: any) => {
      loading && loading.close();

      if (code === 200) {
        this.is_fix_password = false;
        this.$message.success("成功修改密码");
        this.$router.push({ path: "/login" });
        return;
      } else {
        this.$message.error(message);
      }
      return data;
    });
  }
}
